// src/context/AuthContext.js
import React, { createContext, useState } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Initialize from localStorage
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser]   = useState(
    JSON.parse(localStorage.getItem('user') || 'null')
  );

  const isLoggedIn = Boolean(token);

  // login(token, { userId, firstName, userType, companyId })
  const login = (newToken, userData) => {
    const updated = {
      ...userData,
      companyId: userData.companyId || null
    };

    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(updated));

    setToken(newToken);
    setUser(updated);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ token, user, isLoggedIn, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
